<ui-modal
  [isOpened]="isModalOpened"
  modalTitle="Share Strategy"
  (isOpenedChange)="modalChanged($event)"
  class="share-strategy-modal"
>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <div>
      <div class="share-strategy-modal__form-control">
        <label>Recipient</label>
        <div class="clr-select-wrapper">
          <select
            (ngModelChange)="setRecipient($event)"
            class="clr-select"
            [formControlName]="'recipients'"
          >
            <option *ngFor="let user of teamMembers" [ngValue]="user">
              {{ user.email }}
            </option>
          </select>
        </div>
      </div>
      <div class="share-strategy-modal__form-control">
        <label>Strategy Name</label>
        <clr-input-container class="sharing-name">
          <input clrInput formControlName="strategy-name" type="text" />
        </clr-input-container>
      </div>
      @if (enableMessages) {
        <div class="share-strategy-modal__form-control">
          <label>Message</label>
          <clr-textarea-container class="sharing-message">
            <textarea clrTextarea formControlName="message"></textarea>
          </clr-textarea-container>
        </div>
      }
    </div>
    <hr class="hard-return" />
    <div class="modal-footer">
      <div
        style="display: flex; align-items: center; justify-content: flex-end"
      >
        <div class="saving">
          <loading-spinner *ngIf="savingInfo === 'Saving'"></loading-spinner>
          <div
            *ngIf="savingInfo === 'Saved' || savingInfo === 'Failed'"
            [ngClass]="savingInfo === 'Saved' ? 'success' : 'failed'"
          >
            {{ savingInfo }}
          </div>
        </div>
        <button
          class="ui-button primary"
          type="submit"
          [ngClass]="form.valid ? 'ng-valid' : 'ng-invalid'"
          [disabled]="!form?.valid"
        >
          Share
        </button>
      </div>
    </div>
  </form>

  <!-- <clr-datagrid>
        <clr-dg-column *ngFor = "let column of columns">
            {{column}}
        </clr-dg-column>

        <clr-dg-row *clrDgItems="let teamMember of teamMembers" [clrDgItem]="teamMember">
            <clr-dg-cell *ngFor= "let column of columns">
                <ng-container *ngIf="column !== 'select'">
                    {{teamMember[column]}}
                </ng-container>
                <ng-container *ngIf="column === 'select'" >
                    <input type="checkbox" [(ngModel)]="teamMember[column]">
                </ng-container>
            </clr-dg-cell>
        </clr-dg-row>

        <clr-dg-footer>

            <div style="display:flex; align-items: center; justify-content: flex-end;">
                <div class="saving">
                    <loading-spinner *ngIf="savingInfo === 'Saving'"></loading-spinner>
                    <div
                        *ngIf="savingInfo === 'Saved' || savingInfo === 'Failed'"
                        [ngClass]="savingInfo === 'Saved' ? 'success' : 'failed'"
                    >
                        {{ savingInfo }}
                    </div>
                </div>

            </div>
        </clr-dg-footer>
    </clr-datagrid> -->
</ui-modal>
